module.exports = __webpack_public_path__ + "static-portal/img/map-csqp.296d3d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-csqp.png
// module id = CX+g
// module chunks = 4